import { Options } from '../Config/Options.js';

const Navigation = () => {
  const toggleElm = document.getElementById('js-navToggle');
  const menuElm = document.getElementById('js-navMenu');
  if(toggleElm === null || menuElm === null) return;
  toggleElm.addEventListener('click', () => {
    toggleElm.classList.toggle(Options.act);
    menuElm.classList.toggle(Options.act);
  });
}

export default Navigation;